import * as React from "react";
import FormLabelWithDivider from "@/changeservice/components/MissingData/FormLabelWithDivider";

type Props = {
  tooltip?: string;
  label?: string;
  children: React.ReactNode;
  subQuestion?: string;
};

const Row = ({ label, tooltip, subQuestion, children }: Props) => (
  <div className="rowContainer">
    <div className="questionColumn">
      <FormLabelWithDivider desktop leftAlign divider={false} width={16} title={label} tooltip={tooltip} secondary />
      {subQuestion && (
        <div className="subQuestion" style={{ opacity: 0.7, marginBottom: "0.5rem", marginTop: "-0.5rem" }}>
          {subQuestion}
        </div>
      )}
    </div>
    <div className="inputColumn">{children}</div>
  </div>
);

export default Row;
